import { Atom, BookOpen, TrendingUp, GraduationCap, FlaskConical, Sigma, Award, Handshake, Target, ClipboardCheck, Trophy, Briefcase, Lightbulb } from "lucide-react";

export const ASSETS = {
  logo: "https://customer-assets-lxgj4vgw.emergentagent.net/job_physics-choice/artifacts/sxjt3rql_%CE%BD%CE%B5%CE%BF%20%CF%83%CE%B7%CE%BC%CE%B1.png",
  poster: "https://customer-assets-lxgj4vgw.emergentagent.net/job_physics-choice/artifacts/lw246j5m_%CF%84%CE%B5%CE%BB%CE%B9%CE%BA%CE%BF%CF%84%CE%B5%CF%81%CE%B7%20%CE%B1%CF%86%CE%B9%CF%83%CE%B1.png",
  interior: "https://customer-assets-lxgj4vgw.emergentagent.net/job_physics-choice/artifacts/66t497en_%CE%B1%CE%B9%CE%B8%CE%BF%CF%85%CF%83%CE%B1.webp",
  books: "https://customer-assets-lxgj4vgw.emergentagent.net/job_physics-choice/artifacts/5zqwinbq_%CE%B2%CE%B9%CE%B2%CE%BB%CE%AF%CE%B1.webp",
  feynman: "https://customer-assets-lxgj4vgw.emergentagent.net/job_physics-choice/artifacts/4u4bzupl_%CF%86%CE%B1%CE%B9%CE%BC%CE%B1%CE%BD.jpg",
  feynmanBw: "https://customer-assets-lxgj4vgw.emergentagent.net/job_physics-choice/artifacts/appwmm2o_%CF%86%CE%B1%CE%B9%CE%BC%CE%B1%CE%BD2.jpg",
};

export const STEPS = [
  { n: "01", title: "Εμπιστοσύνη", icon: Handshake },
  { n: "02", title: "Στόχοι", icon: Target },
  { n: "03", title: "Μέθοδος", icon: ClipboardCheck },
  { n: "04", title: "Γνώση", icon: BookOpen },
  { n: "05", title: "Επιτυχία", icon: Trophy },
  { n: "06", title: "Σπουδές", icon: GraduationCap },
  { n: "07", title: "Επάγγελμα", icon: Briefcase },
  { n: "08", title: "Δημιουργία", icon: Lightbulb },
];

export const FACEBOOK_URL = "https://www.facebook.com/profile.php?id=100048737681407";
// Κανονικό Page ID για το Facebook Page Plugin (auto-feed)
export const FACEBOOK_PAGE_HREF = "https://www.facebook.com/115341243166167";

export const SOCIALS = [
  { platform: "Facebook", handle: "Φυσική Επιλογή", url: FACEBOOK_URL },
  { platform: "Instagram", handle: "Φυσική Επιλογή", url: "#" },
  { platform: "Viber", handle: "210 50 65 275", url: "#" },
];

export const EVENT_TYPES = {
  "Διαγώνισμα": "#FF2A00",
  "Εκδήλωση": "#002FA7",
  "Αργία": "#0A9D5A",
  "Ενημέρωση": "#F5A623",
  "Πανελλαδικές": "#0A1A4A",
};

export const NAV_LINKS = [
  { id: "hero", label: "Αρχική" },
  { id: "about", label: "Η Φιλοσοφία" },
  { id: "courses", label: "Μαθήματα" },
  { id: "achievers", label: "Επιτυχίες" },
  { id: "news", label: "Νέα" },
  { id: "enroll", label: "Εγγραφή" },
  { id: "contact", label: "Επικοινωνία" },
];

export const GRADES = [
  "Α' Γυμνασίου",
  "Β' Γυμνασίου",
  "Γ' Γυμνασίου",
  "Α' Λυκείου",
  "Β' Λυκείου",
  "Γ' Λυκείου",
];

export const ORIENTATIONS = [
  "Θετικών Σπουδών",
  "Σπουδών Υγείας",
  "Σπουδών Οικονομίας & Πληροφορικής",
  "Ανθρωπιστικών Σπουδών",
  "Δεν ισχύει (Γυμνάσιο)",
];

export const GYMNASIO_SUBJECTS = [
  "Μαθηματικά",
  "Φυσική",
  "Χημεία",
  "Αρχαία Ελληνικά",
  "Νεοελληνική Γλώσσα",
  "Ιστορία",
  "Αγγλικά",
];

export const A_LYKEIOU_SUBJECTS = [
  "Άλγεβρα",
  "Γεωμετρία",
  "Φυσική",
  "Χημεία",
  "Βιολογία",
  "Αρχαία Ελληνικά",
  "Νεοελληνική Γλώσσα & Λογοτεχνία",
];

export const SUBJECT_GROUPS = [
  {
    id: "positive",
    title: "Θετικός Προσανατολισμός",
    tracks: [
      {
        name: "Πολυτεχνικό",
        subjects: ["Νεοελληνική Γλώσσα & Λογοτεχνία", "Μαθηματικά", "Φυσική", "Χημεία"],
      },
      {
        name: "Ιατρικό",
        subjects: ["Νεοελληνική Γλώσσα & Λογοτεχνία", "Φυσική", "Χημεία", "Βιολογία"],
      },
    ],
  },
  {
    id: "economics",
    title: "Οικονομικός Προσανατολισμός",
    tracks: [
      {
        name: "Οικονομίας & Πληροφορικής",
        subjects: [
          "Νεοελληνική Γλώσσα & Λογοτεχνία",
          "Μαθηματικά",
          "Αρχές Οικονομικής Θεωρίας (Α.Ο.Θ.)",
          "Πληροφορική (Α.Ε.Π.Π.)",
        ],
      },
    ],
  },
  {
    id: "theoretical",
    title: "Θεωρητικός Προσανατολισμός",
    tracks: [
      {
        name: "Ανθρωπιστικών Σπουδών",
        subjects: ["Νεοελληνική Γλώσσα & Λογοτεχνία", "Αρχαία Ελληνικά", "Ιστορία", "Λατινικά"],
      },
    ],
  },
];

export const SUBJECT_GROUPS_B = [
  {
    id: "positive",
    title: "Θετικός Προσανατολισμός",
    tracks: [
      {
        name: "Θετικός",
        subjects: [
          "Νεοελληνική Γλώσσα & Λογοτεχνία",
          "Άλγεβρα",
          "Μαθηματικά Προσανατολισμού",
          "Φυσική Γενικής Παιδείας",
          "Φυσική Προσανατολισμού",
          "Χημεία",
        ],
      },
    ],
  },
  {
    id: "economics",
    title: "Οικονομικός Προσανατολισμός",
    tracks: [
      {
        name: "Οικονομικός",
        subjects: [
          "Νεοελληνική Γλώσσα & Λογοτεχνία",
          "Άλγεβρα",
          "Μαθηματικά Προσανατολισμού",
          "Φυσική Γενικής Παιδείας",
          "Αρχές Οικονομικής Θεωρίας (Α.Ο.Θ.)",
          "Πληροφορική (Α.Ε.Π.Π.)",
        ],
      },
    ],
  },
  {
    id: "theoretical",
    title: "Θεωρητικός Προσανατολισμός",
    tracks: [
      {
        name: "Θεωρητικός",
        subjects: [
          "Νεοελληνική Γλώσσα & Λογοτεχνία",
          "Αρχαία Ελληνικά",
          "Ιστορία",
          "Λατινικά",
          "Άλγεβρα",
          "Φυσική Γενικής Παιδείας",
          "Χημεία",
        ],
      },
    ],
  },
];

export const ACHIEVERS = [
  { name: "Κατερίνα Πάδα Σαράντου", school: "Νομική Αθήνας" },
  { name: "Μελίνα Γεωργακοπούλου", school: "Νομική Κομοτηνής" },
  { name: "Ολυμπία-Κωνσταντίνα Βαγγοπούλου", school: "Μηχανολόγων Μηχανικών & Αεροναυπηγών, Παν. Πατρών" },
  { name: "Ηλέκτρα Νάνου", school: "Μηχανικών Βιομηχανικής Σχεδίασης & Παραγωγής" },
  { name: "Στεφανία Χαντούμη", school: "Παιδαγωγικό Δημοτικής Εκπαίδευσης, ΕΚΠΑ" },
  { name: "Νόρα-Αικατερίνη Παπαζαχάρη", school: "Επικοινωνίας & ΜΜΕ, ΕΚΠΑ" },
  { name: "Αθηνά Σωτηροπούλου", school: "Ισπανικής Γλώσσας & Φιλολογίας, ΕΚΠΑ" },
  { name: "Σωτήρης Τζεβελέκος", school: "Μηχανολόγων Μηχανικών, ΠΑΔΑ" },
  { name: "Ευσταθία Τζεβελέκου", school: "Βιομηχανικού Σχεδιασμού, ΠΑΔΑ" },
  { name: "Χρήστος Παζαρακιώτης", school: "Οδοντιατρική Αθηνών" },
  { name: "Μαρκέλλα Αμοιρτζά", school: "Αρχιτεκτονική Πατρών" },
  { name: "Ελένη Μπίλια", school: "Ιατρική Ιωαννίνων" },
  { name: "Σοφία Χατζάκη", school: "Δημόσιας Υγείας, ΠΑΔΑ" },
  { name: "Δανάη Μπαλαούρα", school: "Αρχιτεκτονική Αθηνών" },
  { name: "Αγγελίνα Βιολάκη", school: "Μουσικολογία Θεσσαλονίκης" },
  { name: "Κωνσταντίνος Θεοδωρόπουλος", school: "Πληροφορικής & Τηλεματικής, Χαροκόπειο" },
  { name: "Χρύσα Λύρου", school: "Πολιτικής Επιστήμης, ΕΚΠΑ" },
  { name: "Κωνσταντίνα Κεράνη", school: "Γεωγραφίας, Χαροκόπειο" },
  { name: "Χρήστος Χαρίντι", school: "Νοσηλευτικής, Πελοποννήσου" },
  { name: "Σοφία Γκουρογιάννη", school: "Ιατρική Πατρών" },
  { name: "Σοφία Αντωνίου", school: "Ιατρική Αθηνών" },
  { name: "Ζωή Αντωνίου", school: "Βιοϊατρικών Επιστημών, ΠΑΔΑ" },
  { name: "Εβελίνα Μητσάκη", school: "Φαρμακευτική Αθηνών" },
  { name: "Κωνσταντίνος Κάκος", school: "Πολιτικών Μηχανικών, ΕΜΠ" },
  { name: "Μιχαέλα Αναστοπούλου", school: "Πληροφορική, ΕΚΠΑ" },
  { name: "Δημήτρης Ψωμαδέλης", school: "Μηχανολόγων Μηχανικών & Μηχ. Αεροσκαφών, Πάτρα" },
  { name: "Έλενα Ιωάννου", school: "Εργοθεραπείας, ΠΑΔΑ" },
  { name: "Πηνελόπη Μπαλαούρα", school: "Οδοντιατρική Θεσσαλονίκης" },
  { name: "Πέτρος Λύρος", school: "Ηλεκτρολόγων Μηχ. & Μηχ. Η/Υ, ΠΑΔΑ" },
];

export const SUCCESSES = ACHIEVERS.map((a) => `${a.school} — ${a.name}`);

export const COURSES = [
  {
    icon: Atom,
    title: "Θετικός Προσανατολισμός",
    desc: "Φυσική, Χημεία, Μαθηματικά, Βιολογία & Έκθεση-Λογοτεχνία. Πλήρης προετοιμασία για Ιατρικές, Πολυτεχνικές & Θετικές Σχολές.",
    tag: "Γ' Λυκείου",
  },
  {
    icon: BookOpen,
    title: "Θεωρητικός Προσανατολισμός",
    desc: "Αρχαία, Λατινικά, Ιστορία & Έκθεση-Λογοτεχνία. Μεθοδική προσέγγιση για Νομικές & Φιλολογικές Σχολές.",
    tag: "Γ' Λυκείου",
  },
  {
    icon: TrendingUp,
    title: "Σπουδές στην Οικονομία και την Πληροφορική",
    desc: "Α.Ο.Θ., Μαθηματικά, Πληροφορική (Α.Ε.Π.Π.) & Έκθεση-Λογοτεχνία. Στοχευμένη ύλη για Οικονομικές Σχολές, Σχολές Διοίκησης & Πληροφορικής.",
    tag: "Γ' Λυκείου",
  },
  {
    icon: FlaskConical,
    title: "Α' & Β' Λυκείου",
    desc: "Σταθερή βάση σε όλα τα μαθήματα προσανατολισμού & γενικής παιδείας, με έμφαση στη μεθοδολογία και τη σταδιακή εξοικείωση.",
    tag: "Λύκειο",
  },
  {
    icon: Sigma,
    title: "Γυμνάσιο",
    desc: "Φροντιστηριακή διδασκαλία σε Μαθηματικά, Φυσική, Χημεία & Ελληνικά (Γλώσσα & Αρχαία). Δημιουργούμε αυτοπεποίθηση από νωρίς.",
    tag: "Γυμνάσιο",
  },
  {
    icon: Award,
    title: "Πρότυπα - Ωνάσεια",
    desc: "Στοχευμένη προετοιμασία για τις εξετάσεις εισαγωγής στα Πρότυπα & Πειραματικά Σχολεία και στα Ωνάσεια δημόσια σχολεία (χρηματοδοτούμενα από το Ίδρυμα Ωνάση), με ειδική ύλη σε Μαθηματικά & Ελληνικά.",
    tag: "Δημοτικό & Γυμνάσιο",
  },
  {
    icon: GraduationCap,
    title: "Ιδιαίτερα & Ολιγομελή",
    desc: "Τμήματα μέχρι 5 μαθητές, group των 2 μαθητών και ιδιαίτερα, πλήρως προσαρμοσμένα στον ρυθμό του κάθε μαθητή.",
    tag: "Όλες οι τάξεις",
  },
];

export const TEACHERS = [
  {
    name: "Δρ. Ανδρέας Παπαδόπουλος",
    field: "Φυσική",
    bio: "Διδάκτωρ Φυσικής ΕΚΠΑ, 18 χρόνια εμπειρίας στην προετοιμασία Πανελληνίων.",
    img: "https://images.pexels.com/photos/8197497/pexels-photo-8197497.jpeg",
  },
  {
    name: "Χριστίνα Βασιλείου",
    field: "Μαθηματικά",
    bio: "M.Sc. Εφαρμοσμένων Μαθηματικών ΕΜΠ. Ειδικευμένη στη διδακτική μεθοδολογία.",
    img: "https://images.pexels.com/photos/5212345/pexels-photo-5212345.jpeg",
  },
  {
    name: "Μιχάλης Γεωργίου",
    field: "Χημεία",
    bio: "Χημικός ΑΠΘ. Συγγραφέας βοηθημάτων για τη Χημεία Γ' Λυκείου.",
    img: "https://images.pexels.com/photos/8197527/pexels-photo-8197527.jpeg",
  },
  {
    name: "Ελένη Νικολάου",
    field: "Φιλολογικά",
    bio: "Φιλόλογος ΕΚΠΑ. Εξειδίκευση στα Αρχαία & την Έκθεση με άριστα αποτελέσματα.",
    img: "https://images.pexels.com/photos/5905445/pexels-photo-5905445.jpeg",
  },
];

export const NEWS = [
  {
    date: "15 ΙΟΥΛ 2026",
    tag: "Εγγραφές",
    title: "Έναρξη εγγραφών 2026",
    desc: "Ξεκίνησαν οι εγγραφές για τη σχολική χρονιά 2026–2027. Εξασφαλίστε τη θέση σας στα ολιγομελή τμήματα.",
  },
  {
    date: "25 ΙΟΥΛ 2026",
    tag: "Επιτυχίες",
    title: "Μεγάλη επιτυχία στις Πανελλήνιες!",
    desc: "Οι μαθητές μας πέτυχαν λαμπρά αποτελέσματα και εισαγωγή στις σχολές πρώτης τους επιλογής. Συγχαρητήρια σε όλους!",
  },
  {
    date: "01 ΣΕΠ 2026",
    tag: "Μαθήματα",
    title: "Έναρξη χειμερινών μαθημάτων Γ' Λυκείου",
    desc: "Τρίτη 1 Σεπτεμβρίου ξεκινούν τα μαθήματα της Γ' Λυκείου — εντατική προετοιμασία για τις Πανελλήνιες.",
  },
  {
    date: "07 ΣΕΠ 2026",
    tag: "Μαθήματα",
    title: "Έναρξη χειμερινών μαθημάτων Α' & Β' Λυκείου",
    desc: "Δευτέρα 7 Σεπτεμβρίου ξεκινούν τα μαθήματα για την Α' και Β' Λυκείου. Καλή σχολική χρονιά!",
  },
  {
    date: "14 ΣΕΠ 2026",
    tag: "Μαθήματα",
    title: "Έναρξη χειμερινών μαθημάτων Γυμνασίου",
    desc: "Δευτέρα 14 Σεπτεμβρίου ξεκινούν τα μαθήματα για όλες τις τάξεις του Γυμνασίου.",
  },
  {
    date: "20 ΣΕΠ 2026",
    tag: "Διαγνωστικό",
    title: "Διαγνωστικό τεστ",
    desc: "Κυριακή 20 Σεπτεμβρίου, ώρα 10:00 — αξιολόγηση επιπέδου για τη σωστή κατανομή στα τμήματα.",
  },
];
